module.exports = __webpack_public_path__ + "static/img/6606_phase_function_Paper_Points.52ac781.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6606_phase_function_Paper_Points.png
// module id = 2c82
// module chunks = 0